import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoDocs = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tipoDocs`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_DOCS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoDocs;
